import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    // Load permissions from localStorage on start
    const storedPerms = localStorage.getItem('permissions');
    if (storedPerms) {
      try {
        setPermissions(JSON.parse(storedPerms));
      } catch (e) {
        console.error("Failed to parse permissions", e);
      }
    }
  }, []);

  const hasPermission = (requiredPermission) => {
    // If no permission required, return true
    if (!requiredPermission) return true;
    return permissions.includes(requiredPermission);
  };

  const hasAnyPermission = (requiredPermissions) => {
    if (!requiredPermissions || requiredPermissions.length === 0) return true;
    return requiredPermissions.some(perm => permissions.includes(perm));
  };

  const setAuthData = (data) => {
    if (data && data.permissions) {
      setPermissions(data.permissions);
      localStorage.setItem('permissions', JSON.stringify(data.permissions));
    }
  };

  const logout = () => {
    setPermissions([]);
    localStorage.removeItem('permissions');
    localStorage.removeItem('token');
    localStorage.removeItem('companyId');
    localStorage.removeItem('branchId');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('companyName');
    localStorage.removeItem('mobile');
  };

  return (
    <AuthContext.Provider value={{ permissions, hasPermission, hasAnyPermission, setAuthData, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

// Component to conditionally render content based on permissions
export const PermissionGuard = ({ permission, children, fallback = null }) => {
  const { hasPermission } = useAuth();
  if (hasPermission(permission)) {
    return children;
  }
  return fallback;
};
